import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Login } from '../../core/models/model';
import { LoginConstant } from '../../core/constant/Constant';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from '../../core/services/login.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SettingsService } from '../../core/services/settings.service';
import { PapiAuthService } from '../../core/services/papi-auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseModalComponent } from '../shared/response-modal/response-modal.component';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.css',
})
export class SignInComponent implements OnInit {
  _resetError: any;
  _forgotMessage: any;
  isError: boolean = false;
  isSuccess: boolean = false;
  _message: any;
  showLogin: boolean = true;
  _login: Login = new Login();
  _displayError: boolean = false;
  requiredField: any = LoginConstant;
  _askPassword: Boolean = false;
  _showForgotPassword: boolean = false;
  _showResetPassword: boolean = false;
  _errorDetails: any;
  localStorage: any;
  form: any;
  verificationCode: string = '';
  newPassword: string = '';
  verifyNewPassword: string = '';
  _isLoginSuccess: boolean = false;
  showPasswordField: boolean = false;
  isForgotPassword: boolean = false;
  passwordVisible: boolean= false;
  constructor(
    private spinnerService: NgxSpinnerService,
    private loginService: LoginService,
    private router: Router,
    private SettingsService:SettingsService,
    private authService: PapiAuthService,
    private modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title
  ) {
    this.localStorage = document.defaultView?.localStorage;
  }

  ngOnInit(): void {
    this.titleService.setTitle('Illum');

    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 1000);
  }

  //UserName check if entered or not
  async domainLookup(form: any) {
    if (this._login.UserName != '') {
      if (this._login.UserName.indexOf('@') === -1) {
        this._askPassword = true;
        return;
      }
    } else {
      this._askPassword = false;
    }
  }
  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }
  //Login Validation
  async Login(form: any) {
    this.isForgotPassword = false;
    this._message = '';
    this._resetError = '';
    this.isSuccess = false;
    this.isError = false;
    this.spinnerService.show();
    if (this.ValidateForm(form)) {
      await this.ValidateUser(this._login.UserName, this._login.Password);
      if (this._isLoginSuccess) {
        setTimeout(() => {
          this.router.navigate(['/home']);
        }, 5000);
      }
    }

    setTimeout(() => {
      this.spinnerService.hide();
    }, 5000);
  }
  //validate required form
  ValidateForm(form: any): boolean {
    if (!form.valid) {
      this.loginService.ValidateAllFormFields(form);
      this._displayError = true;

      return false;
    }
    return true;
  }

  async ValidateUser(userName: string, password: string) {
    this._displayError = true;
    await this.loginService.login(userName, password).then(
      async (success) => {
        const decoded = this.loginService.jwt_decode(success.token);
        localStorage.setItem('PAA_USER_ID', decoded.userId);  
        sessionStorage.setItem('User', JSON.stringify(success));
        localStorage.setItem('PAA_AUTH_TOKEN', JSON.stringify(success.token));
        this.authService.schedulePapiRefreshToken(success.token);

        const hasPermission = await this.reverifyPermissionForArcLive();
        if (!hasPermission) {
          return;
        }
        this._isLoginSuccess = true;
        const user = decoded.userId;
        this.SettingsService.getLoginProfile(user).subscribe({
          next: (profile) => {
            localStorage.setItem('PAA_Name', profile.name);
            localStorage.setItem('PAA_org', profile.UserOrganizations[0].Organization.id);
          },
          error: (err) => {
            console.error('Failed to load user profile', err);
          }
        });
        this.SettingsService.getUserRoles().subscribe({
          next: (roles) => {
            localStorage.setItem('PAA_Roles', JSON.stringify(roles));
          },
          error: (err) => {
            console.error('Failed to load user roles', err);
          }
        });
        this.router.navigate(['/home']);
        return;
      },
      (error) => {
        if (error.status === 401 || error.status === 403) {
          this._message = 'Incorrect Username or Password.';
          this.isError = true;
        } else if (error.status === -1) {
          this._message = 'PAPI could not be reached.';
        } else {
          this._message = 'Error has occurred.';
        }
        setTimeout(() => {
          this.spinnerService.hide();
        }, 1000);
      }
    );
  }
  async reverifyPermissionForArcLive(): Promise<boolean> { 
    try {
      const response = await this.loginService.requestActionSessionWithOrganizationIds();
      if (response.rows.length === 0) {
        this.showAlert('Your account does not have permission to log into IllumLive. Please ask your administrator for appropriate permissions.');
        this._isLoginSuccess = false;
        this.authService.clearCredentials();
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    } catch (error) {
      this.showAlert('Error verifying permissions.');
      this.router.navigate(['/login']);
      return false;
    }
  }
  private showAlert(message: string) {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
    });
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.showCancel = false;
    return modalRef.result;
    }
  async ShowForgotPassword() {
    this.isForgotPassword = true;
    this.isError = false;
    this.showPasswordField = false;
    this._showForgotPassword = true;
    this._askPassword = false;
    this.showLogin = false;
  }
  async ForgotPassword() {
    this.isError = false;
    this.isSuccess = false;
    this._message = '';
    this._resetError = '';

    if (this._login.EmailID != '') {
      this.loginService
        .ForgotPassword(this._login.EmailID)
        .then((response) => {
          if (response && response.success) {
            this._message =
              'A password-reset email was sent to you.  Please check your email and enter the verification code below.';
            this.showLogin = false;
            this._showForgotPassword = false;
            this._showResetPassword = true;
          } else {
            this._forgotMessage = 'Error with ForgotPassword';
          }
          return;
        })
        .catch((response) => {
          this._forgotMessage = response?.error?.error?.message;
          this.isError = true;
        });
    }
  }
  onContinueClicked() {
    // Show the password field after clicking Continue
    this.showPasswordField = true;
    this._askPassword = true;
  }
  cancelForgotPassword() {
    this.isForgotPassword = false;
    this._showForgotPassword = false;
    this.showLogin = true;
    this._askPassword = false;
    this.showPasswordField = false;
    this.isError = false;
  }

  resetPassword() {
    this._message = '';
    this._resetError = '';
    this.isError = false;
    this.isSuccess = false;
    if (this._login.EmailID != '') {
      this.loginService
        .ResetPassword(
          this._login.EmailID,
          this.verificationCode,
          this.newPassword,
          this.verifyNewPassword
        )
        .then((response) => {
          if (response && response.success) {
            this._message =
              'Password reset successful. Please log in with your new password.';
            this.showLogin = true;
            this._showResetPassword = false;
            this.isSuccess = true;
          } else {
            this._resetError = 'Error with ForgotPassword';
          }
          return;
        })
        .catch((response) => {
          this._resetError = response?.error?.error?.message;
          this.isError = true;
        });
    }
  }

  cancelResetPassword() {
    this._showResetPassword = false;
    this.showLogin = true;
    this._askPassword = false;
    this.showPasswordField = false;
    this.isError = false;
  }
}
